import Vue from 'vue';

export default Vue.extend({
  template: `
        <span :style="params.style">{{currencyFormatter(params.value)}}</span>
    `,
  data: function () {
    return {};
  },
  methods: {
    currencyFormatter: function(val) {
      var data = Number(val).toFixed(2);
      var formatted = data.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
      return 'Rs.' + `${formatted}`;


    }
  },
  beforeMount() {},
  mounted() {},
  
});
